import { createSelector } from 'reselect';

import { StoreState } from '../../reducers';
import { NotesState, NotesStatus } from './reducer';

const getNotes = (state: StoreState): NotesState => state.notes;
const getCurrentStatus = (state: StoreState): NotesStatus => state.notes.currentStatus;

export const getSortedByDateIds = createSelector(
	getNotes,
	getCurrentStatus,
	(notes, currentStatus) => Object.values(notes[currentStatus])
		.sort((a, b) => {
			const dateA = a.modifiedOn || a.date;
			const dateB = b.modifiedOn || b.date;
			return dateB - dateA;
		})
		.map(({ id }) => id),
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotesPage/selectors.ts